import { isMobile } from "./isMobile";

/*
 * Fixed position footer
 * ----------------------------------------------- */
if (!isMobile()) {
  jQuery(window).on("load scroll", function () {
    var $footer = jQuery("footer");
    var $jsBanner = jQuery(".js-banner");
    var footerTop = $footer.offset().top;
    var windowHeight = jQuery(window).height();

    var scrollTop = jQuery(window).scrollTop();
    // console.log(scrollTop, footerTop - windowHeight);

    // if (scrollTop > 100) {
    //   $jsBanner.addClass("is-scrolled");
    // } else {
    //   $jsBanner.removeClass("is-scrolled");
    // }

    if ($footer.length) {
      if (scrollTop >= footerTop - windowHeight) {
        $jsBanner.addClass("on-footer");
      } else {
        $jsBanner.removeClass("on-footer");
      }
    }
  });
}
